module.exports = "mutation upsertNote($input:UpsertNoteInput!){upsertNote(input:$input){id authorId userId title note created updated}}"